import * as React from "react";
import {Fragment} from "react";
import AssigneeChangeNotification from "../../../model/notification/assignee/AssigneeChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: AssigneeChangeNotification
}

/**
 * Assignee notification toast body.
 */
const NotificationAssigneeChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.getLeadReferenceNumber()}</div>
			<div className={"toast-body"}>
				Assignee(s) changed from <b>{props.notification.displayPreviousAssignees()} </b>
				to <b>{props.notification.displayCurrentAssignees()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationAssigneeChangeBody;